const convertToNumber = (value: string): number => parseInt(value, 10);

export default convertToNumber;
